import request from '@/utils/request';
import { stringify } from 'qs';


// 消息中心列表
export async function getMessageList (params: object) {
  return request(`/api/message/list?${stringify(params)}`, {})
}

// 设置消息为已读
export async function messageRead () {
  return request(`/api/message/read`, {
    method: 'POST'
  })
}


